module.exports = __webpack_public_path__ + "static/media/banner_micro.f59abe6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_micro.png
// module id = 315
// module chunks = 21